jQuery( document ).ready(function($) {

  var winWidth = $(window).width();

  $('.dropdown > a').on('click',function(e) {

    e.preventDefault();
    $(this).parent().toggleClass('is-open');

  });

  $('.wp-block-rss__item-title a').each(function() {
    $(this).attr('target','_blank');
  });

  $('.masthead--arrow').on('click', function(e) {
    e.preventDefault();

    var curEl = $($(this).attr('href'));
    var nextOffset = curEl.next().offset();
    var nextOffsetTop = nextOffset.top - 100;

    $('html, body').animate({
      scrollTop: nextOffsetTop + 'px'
    }, 750);
  });

  $('.content-info--back-to-top').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 750);
  });

  $('.wp-menu--nav li a').on('click', function(e) {

    if ( winWidth <= 767 ) {

      var parent = $(this).closest('.wp-menu--nav');

      if ( !parent.hasClass('is-expanded') ) {
        e.preventDefault();
        parent.addClass('is-expanded');
      } else {

      }

    }

  });

  // Add class to body on hamburger click
  $('.navbar-toggler').on('click', function(e) {
    e.preventDefault();
    $('body').toggleClass('menu-is-open');
  });

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode ? 'is-ie' : 'is-not-ie';

  $('body').addClass('is-loaded').addClass(isIE11);

  // Detect if banner has been scrolled past
  var navScrolled = function() {

    var $window    = $(window);
    var docViewTop = 90;
    var nav        = $('.banner');
    var elemTop    = $window.scrollTop();

    if ( elemTop > docViewTop ) {
      nav.addClass('scrolled');
    } else {
      nav.removeClass('scrolled');
    }

  };

  navScrolled();

  $( window ).scroll( function(e) {
    navScrolled();
  });

  // Detect if element is inview
  var inView = function ( elements ) {

    var $window    = $(window);
    var docViewTop = $window.scrollTop() + $window.height() - ( $window.height() / 10 );

    elements.each( function( index ) {

      if ( !$(this).hasClass('over') ) {

        var elemTop = $(this).offset().top;

        if ( elemTop < docViewTop ) {
          $(this).addClass('over');
        }

      }

    });

  };

  inView( $('.inview') );

  $( window ).scroll( function(e) {
    inView( $('.inview') );
  });

  if ( $('.blank').length > 0 ) {

    $('.blank').each( function(index, value) {
      $(this).find('a').attr('target','_blank').attr('rel','external noreferrer noopener');
    });

  }

});
